import React from 'react';
import { has } from 'lodash';
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from '@material-ui/core';

import Form from 'components/ui/Form';
import AddressFormFields from 'components/general/AddressFormFields';
import PhoneNumber from 'components/ui/PhoneNumber';
import { FormSectionTitle, GridContainer, StyledField } from 'styles/form';

const OrganizationDetails = ({
  errors,
  touched,
  handleChange,
  name,
  shortName,
  contactFirstName,
  contactLastName,
  contactTitle,
  contactEmail,
  contactPhone,
  address,
  city,
  state,
  postalCode,
  country,
  setFieldValue,
}) => (
  <>
    <FormSectionTitle>Details</FormSectionTitle>
    <Form fullWidth>
      <GridContainer>
        <TextField
          color="primary"
          error={touched.name && has(errors, 'name')}
          helperText={touched.name && errors.name}
          label="Organization Name"
          name="name"
          onChange={handleChange}
          value={name}
          variant="outlined"
          required
        />

        <TextField
          color="primary"
          error={touched.shortName && has(errors, 'shortName')}
          helperText={touched.shortName && errors.shortName}
          label="Short Name"
          name="shortName"
          onChange={handleChange}
          value={shortName}
          variant="outlined"
          required
        />

        <AddressFormFields
          address={address}
          country={country}
          city={city}
          state={state}
          postalCode={postalCode}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          fieldsRequired
        />

        <TextField
          color="primary"
          error={touched.contactFirstName && has(errors, 'contactFirstName')}
          fullWidth
          helperText={touched.contactFirstName && errors.contactFirstName}
          label="Contact First Name"
          name="contactFirstName"
          onChange={handleChange}
          value={contactFirstName}
          variant="outlined"
        />

        <TextField
          color="primary"
          error={touched.contactLastName && has(errors, 'contactLastName')}
          fullWidth
          helperText={touched.contactLastName && errors.contactLastName}
          label="Contact Last Name"
          name="contactLastName"
          onChange={handleChange}
          value={contactLastName}
          variant="outlined"
        />

        <TextField
          color="primary"
          error={touched.contactTitle && has(errors, 'contactTitle')}
          helperText={touched.contactTitle && errors.contactTitle}
          label="Contact Title"
          name="contactTitle"
          onChange={handleChange}
          value={contactTitle}
          type="phone"
          variant="outlined"
        />

        <TextField
          color="primary"
          error={touched.contactEmail && has(errors, 'contactEmail')}
          helperText={touched.contactEmail && errors.contactEmail}
          label="Contact Email"
          name="contactEmail"
          onChange={handleChange}
          value={contactEmail}
          variant="outlined"
        />

        <PhoneNumber
          label="Contact Phone Number"
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          value={contactPhone}
          name="contactPhone"
        />
      </GridContainer>
    </Form>
  </>
);

export default OrganizationDetails;
